import useAnalytics from "@Functions/useAnalytics.js";
import { ref, toRaw, computed } from "vue";

export default function useReport () {
    const { store } = useAnalytics();
    const arrRes = ref([]);

    const isLoadingDataChart = computed(() => {
        return store.getters["Reports/isLoading"];
    })
    const reportData = computed(() => {
        return store.getters["Reports/getReport"];
    });

    const alignResultToArr = (event, arr = []) => {
        arrRes.value = [];
        switch (event.target?.value) {
        case 'gender':
            getGender(arr)
            break;
        case 'specialty':
            getSpecialty(arr)
            break;
        case 'disease':
            getDisease(arr)
            break;
        case 'place_prac':
            getPlaceOfPractice(arr)
            break;
        case 'region':
            getRegion(arr)
            break;
        case 'province':
            getProvince(arr)
            break;
        default:
            break;
        }
        return arrRes;
    }

    const getSpecialty = (arr) => {
        arrRes.value = toRaw(arr.result?.specialty);
    }

    const getGender = (arr) => {
        arrRes.value = toRaw(arr.result?.gender);
    }

    const getDisease = (arr) => {
        arrRes.value = toRaw(arr.result?.disease.filter(function (e){ return e.value !== '' }));
    }

    const getPlaceOfPractice = (arr) => {
        arrRes.value = toRaw(arr.result?.place_of_practice);
    }

    const getProvince = (arr) => {
        arrRes.value = toRaw(arr.result?.province);
    }

    const getRegion = (arr) => {
        arrRes.value = toRaw(arr.result?.region);
    }

    const searchApiResult = async (val, search) => {
        arrRes.value = [];
        switch (val) {
        case 'brand':
            await getBrand(search)
            break;
        case 'generic':
            await getGeneric(search)
            break;
        case 'thera_class':
            await getTheraClass(search)
            break;
        default:
            break;
        }
        return arrRes.value
    }

    const getBrand = async (search) => {
        if (search) {
            const params = {
                name: search
            }
            const response = await store.dispatch("Brands/onGetBrands", params);
            for (const results in response) {
                const { id, name, slug } = response[results];
                arrRes.value.push({
                    id: id,
                    label: name,
                    value: name,
                    slug: slug
                })
            }
        }
        return arrRes.value
    }

    const getGeneric = async (search) => {
        if (search) {
            const params = {
                name: search
            }
            if (search.length >= 3) {
                const response = await store.dispatch("Generic/onGetGeneric", params);
                for (const results in response) {
                    const { id, name, slug } = response[results];
                    arrRes.value.push({
                        id: id,
                        label: name,
                        value: name,
                        slug: slug
                    })
                }
            }
        }
    }

    const getTheraClass = async (search) => {
        if (search) {
            const params = {
                name: search,
                search_report: true,
            }
            if (search.length >= 3) {
                const response = await store.dispatch("Sections/searchSections", params);
                for (const results in response) {
                    const { id, name, slug, level } = response[results];
                    arrRes.value.push({
                        id: id,
                        label: name,
                        value: name,
                        slug: slug,
                        level: level
                    })
                }
            }
        }
    }

    const saveReport = async (params) => {
        const response = await store.dispatch('Reports/onSave', params);
        return response;
    }

    const updateReport = async (params, id) => {
        const payload = {
            params: params,
            id: id
        }
        const response = await store.dispatch("Reports/onUpdate", payload);
        return response;
    }

    const getReportList = async (params) => {
        const response = await store.dispatch('Reports/getList', params);
        return response;
    }

    const queryBuild = async (id) => {
        const params = {
            dateFrom: new Date(saveFilters.value.dates.date_from),
            dateTo: new Date(saveFilters.value.dates.date_to),
            id: id
        }

        const response = await store.dispatch('Reports/queryBuild', params)
        return response;
    }

    const deleteTemplate = async (id) => {
        const response = await store.dispatch('Reports/onDelete', id);
        return response;
    }

    const saveFilters = computed(() => {
        return store.getters["Analytics/saveFilters"];
    });

    return {
        alignResultToArr,
        searchApiResult,
        getBrand,
        getGeneric,
        getTheraClass,
        getGender,
        getSpecialty,
        getDisease,
        getPlaceOfPractice,
        getProvince,
        getRegion,
        saveReport,
        getReportList,
        queryBuild,
        updateReport,
        deleteTemplate,
        reportData,
        isLoadingDataChart
    }

}
